import { render, staticRenderFns } from "./MockJobDetailsDialog.vue?vue&type=template&id=4f4cf5ae&"
import script from "./MockJobDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./MockJobDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppBadge: require('/home/forge/portal.gradlinc.co.za/releases/20250707122323/components/global/AppBadge.vue').default,ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20250707122323/components/buttons/ButtonPrimary.vue').default,Modal: require('/home/forge/portal.gradlinc.co.za/releases/20250707122323/components/global/Modal.vue').default})
